export default __webpack_public_path__ + "static/media/img-06.7f935467.png";